const STRAPI_BASE_URL = process.env.STRAPI_API_URL || 'https://strapi.komfortflytt.se';

export const getStrapiURL = (path: string = ''): string => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${STRAPI_BASE_URL}${cleanPath}`;
};
